<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1"><a id="page_4"></a>Published in 2010 by Stewart, Tabori &amp; Chang<br/>An imprint of ABRAMS</p>
<p class="copyright">Text copyright © 2010 by Véronik Avery<br/>Photographs copyright © 2010 by Thayer Allyson Gowdy</p>
<p class="copyright">All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, mechanical, electronic, photocopying, recording, or otherwise, without written permission from the publisher.</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data:<br/>Avery, Véronik.<br/>Knitting 24/7 / by Véronik Avery; photographs by Thayer Allyson Gowdy.<br/>    p. cm.<br/>ISBN 978-1-58479-844-6<br/>1. Knitting—Patterns. 2. Dress accessories. 3. Sweaters. I. Title.<br/>II. Title: Knitting twenty-four seven.<br/>TT825.A845 2010<br/>746.43 ′ 2041—dc22<br/>    2009029919</p>
<p class="copyright">Editor: Liana Allday<br/>Designer: Anna Christian<br/>Production Manager: Jacqueline Poirier</p>
<p class="copyright">The text of this book was composed in Shinn and Promemoria.</p>
<p class="copyright">Stewart, Tabori &amp; Chang books are available at special discounts when purchased in quantity for premiums and promotions as well as fundraising or educational use. Special editions can also be created to specification. For details, contact specialsales@abramsbooks.com or the address below.</p>
<p class="imagef1"><img alt="image" src="images/pub.jpg"/><br/>  115 West 18th Street<br/>  New York, NY 10011<br/>  <a class="nounder" href="http://www.abramsbooks.com" target="_blank">www.abramsbooks.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?7d861eb0